import { normalizeGet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getClipboard = normalizeGet(function () {
  throw new Error('Uni API: getClipboard不支持');
}, CONTAINER_NAME.WEB);
export default getClipboard;